import { render } from "./messageCardOrderStatus.vue?vue&type=template&id=fb480bd4&scoped=true"
import script from "./messageCardOrderStatus.vue?vue&type=script&lang=js"
export * from "./messageCardOrderStatus.vue?vue&type=script&lang=js"

import "./messageCardOrderStatus.vue?vue&type=style&index=0&id=fb480bd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb480bd4"]])

export default __exports__